import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import LivenessV5 from './modules/liveness/v5';
import CardCaptureV1 from './modules/cardCapture/v1/camera';
import AppWrapper from "./App";

const CoreUiComponents = {
    Liveness: LivenessV5,
    CardCapture: CardCaptureV1
  };

// export { LivenessV5 as Liveness, CardCaptureV6 as CardCapture };

// if (typeof window !== "undefined") {
//     window.CoreUiComponents = CoreUiComponents;
// }

export default CoreUiComponents;

if (process.env.NODE_ENV === 'production') {
    console.log = () => {}
    console.error = () => {}
    console.debug = () => {}
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <AppWrapper />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
